"use client";
import "react";
import { j as e } from "./jsx-runtime-CJ-St4mQ.mjs";
const a = {
  className: "base-ui-disable-scrollbar",
  element: /* @__PURE__ */ e.jsx("style", {
    href: "base-ui-disable-scrollbar",
    precedence: "base-ui:low",
    children: ".base-ui-disable-scrollbar{scrollbar-width:none}.base-ui-disable-scrollbar::-webkit-scrollbar{display:none}"
  })
};
export {
  a as s
};
